export default __webpack_public_path__ + "images/logoOSEA.7b0bbf1cdc64eee48eb535a593f1d0a3.svg"